// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file penumbra/custody/v1/custody.proto (package penumbra.custody.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { Message, proto3 } from "@bufbuild/protobuf";
import { AuthorizationData, TransactionPlan } from "../../core/transaction/v1/transaction_pb.js";
import { Validator } from "../../core/component/stake/v1/stake_pb.js";
import { SpendAuthSignature } from "../../crypto/decaf377_rdsa/v1/decaf377_rdsa_pb.js";
import { ValidatorVoteBody } from "../../core/component/governance/v1/governance_pb.js";
import { Address, AddressIndex, FullViewingKey } from "../../core/keys/v1/keys_pb.js";
/**
 * @generated from message penumbra.custody.v1.AuthorizeRequest
 */
export class AuthorizeRequest extends Message {
    /**
     * The transaction plan to authorize.
     *
     * @generated from field: penumbra.core.transaction.v1.TransactionPlan plan = 1;
     */
    plan;
    /**
     * Optionally, pre-authorization data, if required by the custodian.
     *
     * Pre-authorization data is backend-specific, and backends are free to ignore it.
     *
     * Multiple `PreAuthorization` packets can be included in a single request,
     * to support multi-party pre-authorizations.
     *
     * @generated from field: repeated penumbra.custody.v1.PreAuthorization pre_authorizations = 3;
     */
    preAuthorizations = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.custody.v1.AuthorizeRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "plan", kind: "message", T: TransactionPlan },
        { no: 3, name: "pre_authorizations", kind: "message", T: PreAuthorization, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new AuthorizeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AuthorizeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AuthorizeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AuthorizeRequest, a, b);
    }
}
/**
 * @generated from message penumbra.custody.v1.AuthorizeResponse
 */
export class AuthorizeResponse extends Message {
    /**
     * @generated from field: penumbra.core.transaction.v1.AuthorizationData data = 1;
     */
    data;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.custody.v1.AuthorizeResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "data", kind: "message", T: AuthorizationData },
    ]);
    static fromBinary(bytes, options) {
        return new AuthorizeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AuthorizeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AuthorizeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AuthorizeResponse, a, b);
    }
}
/**
 * @generated from message penumbra.custody.v1.AuthorizeValidatorDefinitionRequest
 */
export class AuthorizeValidatorDefinitionRequest extends Message {
    /**
     * The validator definition to authorize.
     *
     * @generated from field: penumbra.core.component.stake.v1.Validator validator_definition = 1;
     */
    validatorDefinition;
    /**
     * Optionally, pre-authorization data, if required by the custodian.
     *
     * Pre-authorization data is backend-specific, and backends are free to ignore it.
     *
     * Multiple `PreAuthorization` packets can be included in a single request,
     * to support multi-party pre-authorizations.
     *
     * @generated from field: repeated penumbra.custody.v1.PreAuthorization pre_authorizations = 3;
     */
    preAuthorizations = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.custody.v1.AuthorizeValidatorDefinitionRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "validator_definition", kind: "message", T: Validator },
        { no: 3, name: "pre_authorizations", kind: "message", T: PreAuthorization, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new AuthorizeValidatorDefinitionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AuthorizeValidatorDefinitionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AuthorizeValidatorDefinitionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AuthorizeValidatorDefinitionRequest, a, b);
    }
}
/**
 * @generated from message penumbra.custody.v1.AuthorizeValidatorDefinitionResponse
 */
export class AuthorizeValidatorDefinitionResponse extends Message {
    /**
     * The authorization signature for the validator definition.
     *
     * @generated from field: penumbra.crypto.decaf377_rdsa.v1.SpendAuthSignature validator_definition_auth = 1;
     */
    validatorDefinitionAuth;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.custody.v1.AuthorizeValidatorDefinitionResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "validator_definition_auth", kind: "message", T: SpendAuthSignature },
    ]);
    static fromBinary(bytes, options) {
        return new AuthorizeValidatorDefinitionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AuthorizeValidatorDefinitionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AuthorizeValidatorDefinitionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AuthorizeValidatorDefinitionResponse, a, b);
    }
}
/**
 * @generated from message penumbra.custody.v1.AuthorizeValidatorVoteRequest
 */
export class AuthorizeValidatorVoteRequest extends Message {
    /**
     * The validator vote to authorize.
     *
     * @generated from field: penumbra.core.component.governance.v1.ValidatorVoteBody validator_vote = 1;
     */
    validatorVote;
    /**
     * Optionally, pre-authorization data, if required by the custodian.
     *
     * Pre-authorization data is backend-specific, and backends are free to ignore it.
     *
     * Multiple `PreAuthorization` packets can be included in a single request,
     * to support multi-party pre-authorizations.
     *
     * @generated from field: repeated penumbra.custody.v1.PreAuthorization pre_authorizations = 3;
     */
    preAuthorizations = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.custody.v1.AuthorizeValidatorVoteRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "validator_vote", kind: "message", T: ValidatorVoteBody },
        { no: 3, name: "pre_authorizations", kind: "message", T: PreAuthorization, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new AuthorizeValidatorVoteRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AuthorizeValidatorVoteRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AuthorizeValidatorVoteRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AuthorizeValidatorVoteRequest, a, b);
    }
}
/**
 * @generated from message penumbra.custody.v1.AuthorizeValidatorVoteResponse
 */
export class AuthorizeValidatorVoteResponse extends Message {
    /**
     * The authorization signature for the validator vote.
     *
     * @generated from field: penumbra.crypto.decaf377_rdsa.v1.SpendAuthSignature validator_vote_auth = 1;
     */
    validatorVoteAuth;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.custody.v1.AuthorizeValidatorVoteResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "validator_vote_auth", kind: "message", T: SpendAuthSignature },
    ]);
    static fromBinary(bytes, options) {
        return new AuthorizeValidatorVoteResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AuthorizeValidatorVoteResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AuthorizeValidatorVoteResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AuthorizeValidatorVoteResponse, a, b);
    }
}
/**
 * A pre-authorization packet.  This allows a custodian to delegate (partial)
 * signing authority to other authorization mechanisms.  Details of how a
 * custodian manages those keys are out-of-scope for the custody protocol and
 * are custodian-specific.
 *
 * @generated from message penumbra.custody.v1.PreAuthorization
 */
export class PreAuthorization extends Message {
    /**
     * @generated from oneof penumbra.custody.v1.PreAuthorization.pre_authorization
     */
    preAuthorization = { case: undefined };
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.custody.v1.PreAuthorization";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "ed25519", kind: "message", T: PreAuthorization_Ed25519, oneof: "pre_authorization" },
    ]);
    static fromBinary(bytes, options) {
        return new PreAuthorization().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PreAuthorization().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PreAuthorization().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PreAuthorization, a, b);
    }
}
/**
 * An Ed25519-based preauthorization, containing an Ed25519 signature over the
 * `TransactionPlan`.
 *
 * @generated from message penumbra.custody.v1.PreAuthorization.Ed25519
 */
export class PreAuthorization_Ed25519 extends Message {
    /**
     * The Ed25519 verification key used to verify the signature.
     *
     * @generated from field: bytes vk = 1;
     */
    vk = new Uint8Array(0);
    /**
     * The Ed25519 signature over the `TransactionPlan`.
     *
     * @generated from field: bytes sig = 2;
     */
    sig = new Uint8Array(0);
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.custody.v1.PreAuthorization.Ed25519";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "vk", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
        { no: 2, name: "sig", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    ]);
    static fromBinary(bytes, options) {
        return new PreAuthorization_Ed25519().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PreAuthorization_Ed25519().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PreAuthorization_Ed25519().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PreAuthorization_Ed25519, a, b);
    }
}
/**
 * @generated from message penumbra.custody.v1.ExportFullViewingKeyRequest
 */
export class ExportFullViewingKeyRequest extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.custody.v1.ExportFullViewingKeyRequest";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new ExportFullViewingKeyRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExportFullViewingKeyRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExportFullViewingKeyRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExportFullViewingKeyRequest, a, b);
    }
}
/**
 * @generated from message penumbra.custody.v1.ExportFullViewingKeyResponse
 */
export class ExportFullViewingKeyResponse extends Message {
    /**
     * The full viewing key.
     *
     * @generated from field: penumbra.core.keys.v1.FullViewingKey full_viewing_key = 1;
     */
    fullViewingKey;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.custody.v1.ExportFullViewingKeyResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "full_viewing_key", kind: "message", T: FullViewingKey },
    ]);
    static fromBinary(bytes, options) {
        return new ExportFullViewingKeyResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExportFullViewingKeyResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExportFullViewingKeyResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExportFullViewingKeyResponse, a, b);
    }
}
/**
 * @generated from message penumbra.custody.v1.ConfirmAddressRequest
 */
export class ConfirmAddressRequest extends Message {
    /**
     * @generated from field: penumbra.core.keys.v1.AddressIndex address_index = 1;
     */
    addressIndex;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.custody.v1.ConfirmAddressRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "address_index", kind: "message", T: AddressIndex },
    ]);
    static fromBinary(bytes, options) {
        return new ConfirmAddressRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ConfirmAddressRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ConfirmAddressRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ConfirmAddressRequest, a, b);
    }
}
/**
 * @generated from message penumbra.custody.v1.ConfirmAddressResponse
 */
export class ConfirmAddressResponse extends Message {
    /**
     * @generated from field: penumbra.core.keys.v1.Address address = 1;
     */
    address;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.custody.v1.ConfirmAddressResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "address", kind: "message", T: Address },
    ]);
    static fromBinary(bytes, options) {
        return new ConfirmAddressResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ConfirmAddressResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ConfirmAddressResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ConfirmAddressResponse, a, b);
    }
}
